import * as React from "react";
import styled from "styled-components";
import classnames from "classnames";

import { Metrics, Palette } from "../../vars";

const OverlayMenuItem: React.SFC<any> = ({ children, className, href }) => (
  <a
    className={classnames("analytics-nav", className)}
    href={
      href.includes("my-account/home/update-plan/move-house.html")
        ? "javascript:void(0)"
        : href
    }
    onClick={() =>
      href.includes("my-account/home/update-plan/move-house.html")
        ? testTarget(href)
        : null
    }
  >
    {children}
  </a>
);

const testTarget = href => {
  if (
    global.adobe &&
    global.adobe.target &&
    typeof global.adobe.target.getOffer === "function" &&
    typeof global.adobe.target.applyOffer === "function"
  ) {
    global.adobe.target.getOffer({
      mbox: "MA-1",
      success: function(offer) {
        if (offer && offer.length) {
          global.adobe.target.applyOffer({
            mbox: "MA-1",
            selector: "body",
            offer: offer
          });
        } else {
          location.pathname = href;
        }
      },
      error: function(status, error) {
        console.error("Error on A/B testing....", status, error);
        location.pathname = href;
      }
    });
  }
};

export default styled(OverlayMenuItem)`
  display: block;
  padding: 22px ${Metrics.Padding.OVERLAY_MENU_ITEM_X}px;
  color: ${Palette.Rebrand.Colours.P6};
  font-size: ${Metrics.FontSizes.OVERLAY_MENU_ITEM_TEXT}px;
  line-height: 24px;
  text-decoration: none;
  border-bottom: 1px solid ${Palette.Rebrand.Colours.G2};

  .style--rebrand & {
    text-decoration: none;
  }

  &:hover,
  &:active {
    color: ${Palette.OVERLAY_MENU_ITEM_TEXT_HOVER};
    text-decoration: none;
  }
`;
